module.exports = __webpack_public_path__ + "img/team_grey.8eab1d41.svg";